export default __webpack_public_path__ + "static/media/DB_2.da4e1054.png";